"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            _timerIds: []
        };
    },


    methods: {
        /**
         * Set a single run timer
         *
         * @param {Function} callback
         * @param {Number} timeout
         *
         * @returns {Number}
         */
        setTimeout: function (_setTimeout) {
            function setTimeout(_x, _x2) {
                return _setTimeout.apply(this, arguments);
            }

            setTimeout.toString = function () {
                return _setTimeout.toString();
            };

            return setTimeout;
        }(function (callback, timeout) {
            var _this = this;

            if (!this.$data._timerIds) {
                return null;
            }

            var timer = setTimeout(function () {
                _this.clearTimeout(timer);

                callback();
            }, timeout);

            this.$data._timerIds.push(timer);

            return timer;
        }),


        /**
         * Set an interval
         *
         * @param {Function} callback
         * @param {Number} timeout
         *
         * @returns {Number}
         */
        setInterval: function (_setInterval) {
            function setInterval(_x3, _x4) {
                return _setInterval.apply(this, arguments);
            }

            setInterval.toString = function () {
                return _setInterval.toString();
            };

            return setInterval;
        }(function (callback, timeout) {
            if (!this.$data._timerIds) {
                return null;
            }

            var timer = setInterval(callback, timeout);

            this.$data._timerIds.push(timer);

            return timer;
        }),


        /**
         * Remove a timer from internal tracking
         *
         * @private
         *
         * @param {Number} timerId
         */
        _removeTimer: function _removeTimer(timerId) {
            this.$data._timerIds = this.$data._timerIds.filter(function (id) {
                return id !== timerId;
            });
        },


        /**
         * Clear a timeout
         *
         * @param {Number} timerId
         *
         * @returns {*}
         */
        clearTimeout: function (_clearTimeout) {
            function clearTimeout(_x5) {
                return _clearTimeout.apply(this, arguments);
            }

            clearTimeout.toString = function () {
                return _clearTimeout.toString();
            };

            return clearTimeout;
        }(function (timerId) {
            this._removeTimer(timerId);

            return clearTimeout(timerId);
        }),


        /**
         * Clear an interval
         *
         * @param {Number} timerId
         *
         * @returns {*}
         */
        clearInterval: function (_clearInterval) {
            function clearInterval(_x6) {
                return _clearInterval.apply(this, arguments);
            }

            clearInterval.toString = function () {
                return _clearInterval.toString();
            };

            return clearInterval;
        }(function (timerId) {
            this._removeTimer(timerId);

            return clearInterval(timerId);
        })
    },

    beforeDestroy: function beforeDestroy() {
        var _this2 = this;

        if (this.$data._timerIds) {
            this.$data._timerIds.forEach(function (id) {
                _this2.clearTimeout(id);
            });

            this.$data._timerIds = null;
        }
    }
};